<template>
    <ParentPage page-type="freelancers-parent-page"></ParentPage>
</template>
<script lang="ts" setup>
    import {useWebsitePageView} from '#imports';
    import ParentPage from '~/components/ParentPage.vue';

    useWebsitePageView('cms', 'freelancers');
</script>
